import type { ReactElement, ReactNode } from 'react';
import { UNSAFE_PortalProvider } from 'react-aria'; // not exported by react-aria-components 1.21.1
import { RouterProvider } from 'react-aria-components';
import { Announcer } from './Announcer';

export interface UiProviderProps {
  navigate: (href: string) => void;
  useHref?: (href: string) => string;
  portalContainer: () => HTMLElement;
  children: ReactNode;
}

export function UiProvider({
  navigate,
  useHref,
  portalContainer,
  children
}: UiProviderProps): ReactElement {
  return (
    <RouterProvider navigate={navigate} useHref={useHref}>
      <UNSAFE_PortalProvider getContainer={portalContainer}><Announcer>{children}</Announcer></UNSAFE_PortalProvider>
    </RouterProvider>
  );
}
